// ==========================================================================
// SignalFix v2 — Campaign summary panel
// --------------------------------------------------------------------------
// Compact "Campagna di rilievo" panel shown top-left. Replaces the old
// vehicle-icon popup: the monitored distance (and survey date, when known)
// stay visible without opening a dedicated map element, as the spec requires.
// ==========================================================================

import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import { FaRoad, FaRegCalendarAlt } from "react-icons/fa";

const formatKm = (distance) => {
  if (distance === null || distance === undefined || isNaN(distance)) return null;
  // Italian formatting: 36,8 km
  return `${Number(distance).toFixed(1).replace(".", ",")} km`;
};

const CampaignSummaryPanel = ({ distance, date, location, loading }) => {
  const { t } = useTranslation();
  const km = formatKm(distance);

  return (
    <div className="signalfix-campaign-panel">
      <div className="signalfix-campaign-title">
        {t("signalFix.campaign.title", "Campagna di rilievo")}
      </div>

      <div className="signalfix-campaign-row">
        <FaRoad className="signalfix-campaign-icon" />
        <div>
          <span className="signalfix-campaign-label">
            {t("signalFix.campaign.monitoredPath", "Percorso monitorato")}
          </span>
          <div className="signalfix-campaign-value">
            {loading ? <Spin size="small" /> : km || "—"}
          </div>
          {location && !loading && (
            <div className="signalfix-campaign-sub">{location}</div>
          )}
        </div>
      </div>

      {date && (
        <div className="signalfix-campaign-row">
          <FaRegCalendarAlt className="signalfix-campaign-icon" />
          <div>
            <span className="signalfix-campaign-label">
              {t("signalFix.campaign.surveyDate", "Data rilievo")}
            </span>
            <div className="signalfix-campaign-value">{date}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignSummaryPanel;
